<template>
  <sidebar-right
    @overlayClicked="outside"
    :class="[
      'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720',
      { open: show }
    ]"
  >
    <div class="bg-white md__card--holder clearfix">
      <div>
        <!-- Card header -->
        <div
          class="card-header d-flex align-items-center"
          :class="{
            'blue-class': $route.name == 'projects',
            'green-class': $route.name == 'tasks.home',
            'yellow-class': $route.name == 'timesheet.home'
          }"
        >
        
          <h4 class="h3 mb-0">
            <span class="right-bracket">{ </span> Invoice
          </h4>
        </div>

        <div class="card-header">
          <p>
            Pricing is simple, $5 AUD per month
          </p>
        </div>
      </div>

      <div
        class="payment-block"
      >
        <div class="card-body text-center">
          <h2 class="text-success">Invoice Form here</h2>
        </div>
      </div>

      
      <!-- <div class="card-body">
     
    </div> -->
    </div>
  </sidebar-right>
</template>

<script>
import swal from "sweetalert2";
import { VueAvatar } from "vue-avatar-editor-improved";
import "sweetalert2/dist/sweetalert2.css";
import { mapState, mapActions, mapMutations } from "vuex";
import Modal from "@/components/Modal";
import AssignCompany from "@/app/components/AssignCompany.vue";
import axios from "axios";
import UserPicker from "@/app/components/UserPicker.vue";
import SidebarRight from "../layout/SidebarRight.vue";
import { required, minLength, between, email } from "vuelidate/lib/validators";

export default {
  name: "Finance",
  props: ["show", "fullWidth", "project", "task"],
  components: {
    VueAvatar,
    AssignCompany,
    UserPicker,
    SidebarRight
  },

  data() {
    return {
      pendingProjects: [
        { id: 1, name: "Demo Project" },
        { id: 2, name: "Mobile App Development" },
        { id: 3, name: "Next JS Project" },
        { id: 4, name: "Bracket development and release" },
        { id: 5, name: "My Favourite One" }
      ],
      userInvite: {},
      form: {
        customer: {},
        rebillCC: {}
      },
      showCurrency: true,
      paymentMode: "me",
      paymentInfo: {},
      editMode: false, //later will use profile.hasCard

      selects: {
        showCurrency: "",
        currency: [
          { value: "USD", label: "United states", symbol: "$" },
          { value: "AUD", label: "Australia", symbol: "$" },
          { value: "EUR", label: "Euro", symbol: "€" },
          { value: "GBP", label: "Pound Sterling", symbol: "£" },
          { value: "CAD", label: "Canada", symbol: "$" }
        ]
      },
      showCropper: false
    };
  },

  validations: {
    form: {
      customer: {
        first_name: {
          required
        }
      },
      rebillCC: {
        name: {
          required
        },
        number: {
          required
        },
        cvc: {
          required
        },
        exp_month: {
          required
        },
        exp_year: {
          required
        }
      }
    }
  },

  watch: {
    project() {
        this.fetchPayment();
    }
  },

  computed: {
    ...mapState("user", ["profile", "banners"]),
    ...mapState("common", ["countries"]),
    extraPayableSelectedProjects() {
      return (this.paymentInfo.projects || []).filter(p => p.checked);
    },

    extraPayableProjects() {
      return (this.paymentInfo.projects || []).filter(
        p => p.id != this.project.id
      );
    },

    currentProject() {
      return this.paymentInfo.currentProject;
    },

    getTotalPayableCost() {
      return (this.extraPayableSelectedProjects.length + 1) * 5;
    },

    getCompanyName() {
      if (this.profile.company && this.profile.company.website) {
        const website = this.profile.company.website;
        const matches = website.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        const domain = matches && matches[1]; // domain will be null if no match is found
        return domain;
      }
    }
  },

  mounted() {
    this.$nextTick(async () => {
      await this.fetchPayment();

      this.form = {
        ...this.form,
        customer: { ...this.profile, image: null, user_preference: null }
      };

      if (this.currentProject) {
        this.userInvite = this.currentProject.financePayer;
      }
    });
  },
  methods: {
    ...mapActions("user", [
      "savePreference",
      "updateProfileInfo",
      "deleteBanner",
      "saveBanner",
      "fetchBanners"
    ]),
    ...mapActions("project", [
      "invitePayersToProject",
      "fetchPaymentInfo",
      "createPayement"
    ]),

    async fetchPayment() {
      try {
        let res = await this.fetchPaymentInfo(this.project.id);
        this.paymentInfo = res;
        this.editMode = !this.paymentInfo.billingDetails;
      } catch (e) {
        console.log("eeeeee", e);
        this.$snack.success(
          e.response.data.title || "Error fetching payment info"
        );
      }
    },

    async _onPayNowClicked() {
      if (this.editMode) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return false;
        }

        try {
          const body = {
            amount: this.getTotalPayableCost * 100,
            ...this.form,
            assets: [...this.extraPayableSelectedProjects, this.project]
          };
          let res = await this.createPayement(body);
          this.$snack.success(res.message);
          this.fetchPayment();
          this.$emit("paymentSuccess");
        } catch (e) {
          this.$snack.success(
            e.response.data.message || "Error creating payment"
          );
        }
      } else {
        try {
          const body = {
            amount: this.getTotalPayableCost * 100,
            assets: [...this.extraPayableSelectedProjects, this.project]
          };
          let res = await this.createPayement(body);
          this.$snack.success(res.message);
          this.fetchPayment();
          this.$emit("paymentSuccess");
        } catch (e) {
          console.log(e, "error occured while paying");
          this.$snack.success(
            e.response.data.message || "Error creating payment"
          );
        }
      }
    },

    async _inviteClicked() {
      let body = {
        ...this.userInvite,
        assets: [...this.extraPayableSelectedProjects, this.project]
      };
      try {
        let res = await this.invitePayersToProject(body);
        this.$snack.success("Payer has been invited successfully");
        this.fetchPayment();
        this.$emit("inviteSuccess");
      } catch (e) {
        this.$snack.success(e.response.data.message || "Error inviting payer");
      }
    },

    outside() {
      this.$emit("outSideClicked");
    }
  }
};
</script>

<style lang="scss">
.el-input input.el-input__inner {
  border-radius: 5px;
}
h4 span.right-bracket {
  color: #fddf43;
  font-size: 30px;
}
</style>
